import { i18n } from './localization'
import { numberToCurrency } from './numberToCurrency'

export const discountPriceFormatter = (
  showFromText: string,
  plusClubPrice: number,
  inPlusClub: boolean,
  priceFirst: string,
  priceSecond: string,
  currency: string,
) => {
  const firstPrice =
    i18n.global.locale.value === 'hu'
      ? numberToCurrency(priceFirst, showFromText)
      : `${showFromText} ${numberToCurrency(priceFirst, currency)}`

  const secondPrice =
    i18n.global.locale.value === 'hu'
      ? numberToCurrency(priceSecond, showFromText)
      : `${showFromText} ${numberToCurrency(priceSecond, currency)}`

  return plusClubPrice !== null && inPlusClub ? firstPrice : secondPrice
}
